import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import YesOrNoCheckbox from '../../../YesOrNoCheckbox/YesOrNoCheckboxView';

export const validator = hasPlanToGetMortgage => () => {
  if (hasPlanToGetMortgage !== true && hasPlanToGetMortgage !== false) {
    return ['Please select an option'];
  }
  return [];
};

class PlanToGetMortgage extends Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const {
      prepopulateHasMortgage, workflowId, isPopulated, hasMortgage,
    } = this.props;

    if (!previousIsPopulated && isPopulated && hasMortgage) {
      prepopulateHasMortgage(workflowId);
    }
  }

  render() {
    const {
      branch,
      workflowId,
      hasPlanToGetMortgage,
      onHasPlanToGetMortgageChanged,
      alreadyHadMortgage,
      nextIterators,
      onPostProcess,
      onPostSave,
    } = this.props;

    return (
      <AdvWorkflowStep branch={branch} workflowId={workflowId} canSkip={alreadyHadMortgage}>
        <Validation
          workflowId={workflowId}
          validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.HasPlanToGetMortgage`}
        />

        <h2>Do you plan to get a mortgage?</h2>
        <YesOrNoCheckbox
          checked={hasPlanToGetMortgage}
          onClick={onHasPlanToGetMortgageChanged(workflowId)}
        />
        <Navigation
          nextIterators={nextIterators}
          dirtyGraphNodes={[]}
          validator={validator(hasPlanToGetMortgage)}
          validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.HasPlanToGetMortgage`}
          workflowId={workflowId}
          backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
          doNotSave={hasPlanToGetMortgage}
          onPostProcess={onPostProcess(hasPlanToGetMortgage)}
          onPostSave={onPostSave(hasPlanToGetMortgage, workflowId)}
        />
      </AdvWorkflowStep>
    );
  }
}

PlanToGetMortgage.defaultProps = {
  hasPlanToGetMortgage: null,
};

PlanToGetMortgage.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  hasPlanToGetMortgage: PropTypes.bool,
  onHasPlanToGetMortgageChanged: PropTypes.func.isRequired,
  hasMortgage: PropTypes.func.isRequired,
  alreadyHadMortgage: PropTypes.bool.isRequired,
  prepopulateHasMortgage: PropTypes.func.isRequired,
  isPopulated: PropTypes.bool.isRequired,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  onPostProcess: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
};

export default PlanToGetMortgage;
